import MultipleSelect from 'emerald-ui/lib/MultipleSelect';
import populateDocs from './utils/populateDocs';

let zIndex = 1000;

function getZIndex() {
  zIndex -= 1;
  return zIndex;
}

export default {
  ...populateDocs([{ component: MultipleSelect, componentName: 'MultipleSelect' }], 'MultipleSelect'),
  description: 'Used for choosing one or more items from a list via a dropdown menu.',
  codeSamples: [
    {
      title: 'Default',
      scope: { MultipleSelect },
      whiteBackground: true,
      style: { zIndex: getZIndex() },
      code: `<MultipleSelect label="Label" id="s1">
  <option value="first">First</option>
  <option value="second">Second</option>
  <option value="third">Third</option>
  <option value="fourth">Fourth</option>
  <option value="fifth" tooltip="This is a tooltip">Fifth</option>
</MultipleSelect>`,
    },
    {
      title: 'With custom options',
      scope: { MultipleSelect },
      whiteBackground: true,
      style: { zIndex: getZIndex() },
      code: `<MultipleSelect label="Label" id="s1">
  <option key="1" value="default" captionText="default">
    <div ariaLabel="Default">
      <span className="eui-status-indicator eui-status-indicator-default" />{' '}
      Default
    </div>
  </option>
  <option key="2" value="info" captionText="info">
    <div ariaLabel="Info">
      <span className="eui-status-indicator eui-status-indicator-info" />{' '}
      Info
    </div>
  </option>
</MultipleSelect>`,
    },
  ],
};
